import mutations from './mutations'
import actions from './actions'


let menuData = {}
try {
  const unem = localStorage.getItem('unem')
  if (unem) {
    menuData = JSON.parse(unem)
  }
} catch (e) {
}

const state = {
  session: {},
  login_url: process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000/oauth/token',
  menu: menuData
}

export default {
  state,
  mutations,
  actions
}